import { useState, useEffect, useRef } from 'react';
import { FaMobileAlt, FaAndroid, FaSafari } from 'react-icons/fa';

const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent);
const isStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches ||
  window.navigator.standalone ||
  document.referrer.includes('android-app://');

const AddToHomeScreen = () => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const timerRef = useRef(null);

  const academyName = 'Licorne Professional Academy';
  const academyDomain = 'https://tn.licorne-academy.com/';

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/sw.js')
        .then(() => console.log('SW registered'))
        .catch((err) => console.log('SW registration failed:', err));
    }

    if (localStorage.getItem('pwaPromptShown')) return;
    if (isStandalone()) return;

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      triggerPrompt();
    };

    if (isIOS()) {
      triggerPrompt();
    } else {
      window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    }

    return () => {
      window.removeEventListener(
        'beforeinstallprompt',
        handleBeforeInstallPrompt
      );
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  const triggerPrompt = () => {
    setShowPrompt(true);
    localStorage.setItem('pwaPromptShown', 'true');

    timerRef.current = setTimeout(() => {
      setShowPrompt(false);
    }, 8000);
  };

  const handleInstall = async () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    if (deferredPrompt) {
      try {
        deferredPrompt.prompt();
        await deferredPrompt.userChoice;
      } catch (err) {
        console.error('Error during install prompt:', err);
      }
      setDeferredPrompt(null);
    }
    setShowPrompt(false);
  };

  const handleCancel = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    setShowPrompt(false);
  };

  if (!showPrompt) return null;

  return (
    <div className='pwa-install-banner' role='dialog' aria-label='Install app'>
      <div className='pwa-install-body'>
        <div className='pwa-install-brand'>
          <img src='/licorne.png' alt='' width={36} height={36} />
          <h5>{academyName}</h5>
        </div>

        <div className='pwa-install-title'>
          {isIOS() ? (
            <>
              <FaMobileAlt className='me-2' />
              <FaSafari className='me-2' />
              <span>Ajouter à l&apos;écran d&apos;accueil</span>
            </>
          ) : (
            <>
              <FaAndroid className='me-2' />
              <span>Installer l&apos;application</span>
            </>
          )}
        </div>

        {isIOS() ? (
          <div className='pwa-install-copy'>
            <ol>
              <li>
                Appuyez sur <span className='pwa-chip'>Partager</span>
              </li>
              <li>
                Sélectionnez <strong>Sur l&apos;écran d&apos;accueil</strong>
              </li>
            </ol>
            <div className='pwa-install-card'>
              <div className='fw-bold'>{academyName}</div>
              <div className='pwa-muted'>{academyDomain}</div>
            </div>
          </div>
        ) : (
          <div className='pwa-install-copy'>
            <p>Installez {academyName} pour une meilleure expérience :</p>
            <ul>
              <li>Accès plus rapide aux formations</li>
              <li>Chargement plus fluide</li>
              <li>Interface type application</li>
            </ul>
          </div>
        )}

        <div className='pwa-install-actions'>
          <button
            type='button'
            className='btn btn-teal'
            onClick={isIOS() ? handleCancel : handleInstall}
          >
            {isIOS() ? 'Compris' : 'Installer'}
          </button>
          <button
            type='button'
            className='btn btn-outline-secondary rounded-pill'
            onClick={handleCancel}
          >
            Plus tard
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddToHomeScreen;
